// Rozpoznání prostředí z adresy. Neprodukční prostředí (test, feature) dostanou
// barevný pruh nahoře, aby bylo na první pohled jasné, že data nejsou ostrá.
// Produkce (eshop.ttnz.cz i …-prod.…) žádný banner nemá.

export function envKindFor(hostname) {
  const h = hostname || "";
  if (/-feature\b|-feature\./.test(h)) return "feature";
  if (/-test\b|-test\./.test(h)) return "test";
  return "prod";
}

export const ENV_BANNERS = {
  test: "⚠️ TESTOVACÍ PROSTŘEDÍ — data slouží jen ke zkoušení, objednávky nejsou reálné.",
  feature:
    "🧪 FEATURE PROSTŘEDÍ — rozpracovaná funkcionalita, data jen ke zkoušení. Není to test ani ostrý provoz.",
};
